import { useMemo, useState } from "react";
import { Receipt, Zap } from "lucide-react";
import { Empty, Panel } from "@/components/Shared";
import { Button } from "@/components/ui/button";
import { HistorySummary } from "@/components/pos/history/HistorySummary";
import { HistoryFilters, EMPTY_FILTER, QUICK } from "@/components/pos/history/HistoryFilters";
import { HistoryRow } from "@/components/pos/history/HistoryRow";
import { receiptBelgeNo } from "@/lib/receipt";

const PAGE = 40;
const norm = (s) => String(s || "").toLocaleLowerCase("tr");

// Fiş & Satış Geçmişi (yalnız yönetici): özet şeridi · hızlı tarih · arama · kompakt satırlar (tıkla → kalemler) · Yazdır / İade / ⋯
export function SalesHistoryPanel({ history, contactOptions, onNew, actions }) {
  const [f, setF] = useState(() => ({ ...EMPTY_FILTER }));
  const [openId, setOpenId] = useState(null);
  const [limit, setLimit] = useState(PAGE);
  const filtered = useMemo(() => {
    const q = norm(f.q);
    return history.filter((s) => {
      const d = (s.created_at || "").slice(0, 10);
      if (f.start && d < f.start) return false;
      if (f.end && d > f.end) return false;
      if (f.pay && (s.payment_method || "nakit") !== f.pay && !(s.payments || []).some((p) => p.method === f.pay)) return false;
      if (f.mode && (s.mode || "genel") !== f.mode) return false;
      if (f.contact && norm(s.title).trim() !== norm(f.contact).trim()) return false;
      if (q && !(norm(receiptBelgeNo(s)).includes(q) || norm(s.title).includes(q) || (s.items || []).some((it) => norm(it.name).includes(q) || norm(it.code).includes(q)))) return false;
      return true;
    });
  }, [history, f]);
  const label = (QUICK.find(([k]) => k === f.quick) || [])[1] || "Seçim";
  const visible = filtered.slice(0, limit);

  return (
    <Panel title="Fiş & Satış Geçmişi" subtitle="Hızlı satış fişleri · satıra tıklayınca kalemler açılır" icon={Receipt} testid="quick-sale-sales-history-table"
      actions={<span className="text-xs font-bold tnum rounded-full bg-muted px-2 py-0.5" data-testid="qs-history-count">{history.length} fiş</span>}>
      <div className="space-y-3">
        <HistorySummary sales={filtered} label={label} />
        <HistoryFilters f={f} setF={(v) => { setF(v); setLimit(PAGE); }} contactOptions={contactOptions} count={filtered.length} />
        {history.length === 0 ? (
          <Empty title="Henüz hızlı satış yok" desc="Yeni Satış Başlat ile ilk fişi kesin." action={<Button size="sm" onClick={onNew} data-testid="qs-empty-new-btn"><Zap className="h-4 w-4 mr-1.5" />Yeni Satış Başlat</Button>} />
        ) : filtered.length === 0 ? (
          <Empty title="Eşleşen fiş yok" desc="Tarih aralığını ya da filtreleri değiştirin." />
        ) : (
          <div className="space-y-2" data-testid="qs-history-list">
            {visible.map((s) => <HistoryRow key={s.id} s={s} open={openId === s.id} onToggle={() => setOpenId(openId === s.id ? null : s.id)} a={actions} />)}
            {filtered.length > limit && (
              <div className="flex justify-center pt-1">
                <Button variant="outline" size="sm" className="rounded-xl" onClick={() => setLimit((l) => l + PAGE)} data-testid="qs-history-more">Daha fazla göster ({filtered.length - limit} fiş daha)</Button>
              </div>
            )}
          </div>
        )}
      </div>
    </Panel>
  );
}
